// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CoordinationLocation\ApiCoordinationLocation.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Coordination, CoordinationData, CoordinationOptions } from 'data/models/Coordination';
import { Location, LocationData, LocationOptions } from 'data/models/Location';
import { CoordinationLocationType } from 'server/enums/CoordinationLocationType';

// CoordinationLocationData is the class that CoordinationLocation serializes to/from
export interface CoordinationLocationData {
    CoordinationId : number;
    LocationId : number;
    Type : CoordinationLocationType;
	
    Coordination : CoordinationData | null;
    Location : LocationData | null;
	
}

// CoordinationLocationOptions is the class which may be passed to the CoordinationLocation constructor to define optional initial data values
export interface CoordinationLocationOptions {
    CoordinationId : number;
    LocationId : number;
    Type : CoordinationLocationType;
	
    Coordination? : CoordinationOptions | null;
    Location? : LocationOptions | null;
	
}

export class CoordinationLocation {
    public CoordinationId : DataSignal<number>;
    public LocationId : DataSignal<number>;
    public Type : DataSignal<CoordinationLocationType>;
	
    public Coordination : DataSignal<Coordination | null>;
    public Location : DataSignal<Location | null>;
	

    constructor();
    constructor(data : CoordinationLocationOptions);
    constructor(data: CoordinationLocationOptions | null = null) {
        this.CoordinationId = jsonableObservable(S.value<number>(data && data.CoordinationId !== undefined ? data.CoordinationId : 0));
        this.LocationId = jsonableObservable(S.value<number>(data && data.LocationId !== undefined ? data.LocationId : 0));
        this.Type = jsonableObservable(S.value<CoordinationLocationType>(data && data.Type !== undefined ? data.Type : 0));
	    
        this.Coordination = S.value<Coordination | null>(null);
        this.Location = S.value<Location | null>(null);
	    
    }

    static key(obj : CoordinationLocation) {
        return obj.CoordinationId() + '\u2618' + obj.LocationId() + '\u2618' + obj.Type();
    }
    
    static dataKey(obj : CoordinationLocationOptions) {
        return obj.CoordinationId + '\u2618' + obj.LocationId + '\u2618' + obj.Type;
    }

    static update(obj : CoordinationLocation, data : CoordinationLocationOptions) {
        S.freeze(() => {
            if (data.CoordinationId !== undefined) obj.CoordinationId(data.CoordinationId);
            if (data.LocationId !== undefined) obj.LocationId(data.LocationId);
            if (data.Type !== undefined) obj.Type(data.Type);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/CoordinationLocation.ts